// extracted by mini-css-extract-plugin
export default {"Main":"Description_Main__t+naY","Title":"Description_Title__ADj++","SubTitle":"Description_SubTitle__xibM7","SubTitle2":"Description_SubTitle2__dCBgT"};